export default __webpack_public_path__ + "static/media/eventsnap-logo-outline.0e735599.png";